import { useService } from '@toeverything/infra';
import { useEffect } from 'react';

import { NotificationSocketService } from '../services/notification-socket';

/**
 * Resolves the otherwise lazy ServerScope service and connects even when the
 * ServerStarted event happened before the application shell mounted.
 */
export const NotificationRealtimeBootstrap = () => {
  const notificationSocketService = useService(NotificationSocketService);

  useEffect(() => {
    notificationSocketService.start();
  }, [notificationSocketService]);

  return null;
};
